import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import { useAuth } from "../contexts/AuthContext";

// Gate for the authenticated /app area. Shows a spinner while the auth state
// hydrates, then redirects unauthenticated users to /login (remembering where
// they were trying to go, query string included). A discount code in that
// link is kept by DiscountCapture (AppProviders) before this redirect.
const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <FaSpinner className="animate-spin text-4xl text-white" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
